import styles from './HostServiceDialog.module.css'
import { Dialog, IconButton, Popper } from '@mui/material'
import { useBreakpointUp } from 'shared/hooks/useBreakpointQueries'
import { BedroomsFilterContainer } from './containers/BedroomsFilterContainer'
import { BedsFilterContainer } from './containers/BedsFilterContainer'
import { PetsFilterContainer } from './containers/PetsFilterContainer'
import { useEffect, useState } from 'react'
import { ApplyButton } from './presentations/ApplyButton'
import CloseIcon from '@mui/icons-material/Close'
import { ClearAllButton } from './presentations/ClearAllButton'
import { HostServiceCard } from './presentations/HostServiceCard'

interface HostServiceDialogProps {
    open: boolean
    hostService: any
    spyId?: number
    onOpen?: (event: any) => void
    onClose?: (event: any) => void
    onOk?: (event: any) => void
    onCancel?: (event: any) => void
    onStartPropertySpy: (event: any) => void
    onStopPropertySpy: (event: any) => void
}

export const HostServiceDialog = (props: HostServiceDialogProps): JSX.Element => {
    const {
        open,
        hostService,
        onOk,
        onCancel,
        onClose,     
        spyId,
        onStartPropertySpy,
        onStopPropertySpy
    } = props
 

    const isXlWidthScreenOrMore = useBreakpointUp('xl')


    const anchorVirtualElement: any = {
        getBoundingClientRect: () => {
            return {
                width: window.innerWidth,
                height: 0,
                top: 90,
                right: 0,
                bottom: 0,
                left: 0,
            }
        },
    }


    const handleOkButtonClick = (event: any) => {
        onOk?.(event)
    }

    const handleDialogClose = (event: any) => {
        onClose?.(event)
    }

    const handleHostServiceCardStartPropertySpy = () => {
        onStartPropertySpy?.(hostService)
    }

    const handleHostServiceCardStopPropertySpy = () => {
        onStopPropertySpy?.(hostService)
    }

    return (
        <Dialog
            onClose={handleDialogClose}
            open={open}
            fullScreen
        >
            <div className={styles.Dialog__Content}>
                <div className={styles.Dialog__StartContainer}>
                    <div></div>
                    <div className={styles.Dialog__TitleContainer}>
                        <div className={styles.Dialog__Title}>{hostService?.name || ''}</div>
                    </div>
                    <div>
                        <IconButton
                            className={styles.CloseSearchButton}
                            aria-label=""
                            size="small"
                            onClick={handleDialogClose}
                        >
                            <CloseIcon
                                className={styles.CloseSearchButton__Icon}
                            />
                        </IconButton>
                    </div>
                </div>
                <div className={styles.Dialog__CenterContainer}>
                    <HostServiceCard 
                        hostService={hostService}
                        spyId={spyId}
                        onStartPropertySpy={handleHostServiceCardStartPropertySpy}
                        onStopPropertySpy={handleHostServiceCardStopPropertySpy}
                    />
                </div>
                <div className={styles.Dialog__EndContainer}>
                    <ApplyButton
                        onClick={handleOkButtonClick}
                    />
                </div>
            </div>   
        </Dialog>

    )
}